export class NoteRequest {
  contractNumber: string;
  claimUid: string;
  uid: string;
  noteType: string;
  noteMessage: string;
  noteLevel: string;
  examiner: string;
  createdBy: string;
  auditNoteFlag: boolean;
  userID: string;
  userName: string;
  needDiary: boolean;
  fileNumber: string;
}
